import StoreHelper from '../../../store/helper'
import DomHelper from '../../DomHelper'
import EventBus, { Events } from '../../../event-bus'
import { Directions } from '../index'

export const onDroppableBubbleDrop = (component, direction, e) => {
  DomHelper.resetElementScale(e.target)
  DomHelper.playPulseScaleAnimation(e.target)

  StoreHelper.removeDragElement(StoreHelper.getActiveViewKey(), StoreHelper.getDragElement())

  const target = _.isEqual(direction, Directions.UPWARDS) ? StoreHelper.getActiveView().parent.parent : component.item
  EventBus.$emit(Events.B_MENU_ITEM_PARENT_CHANGED, StoreHelper.getDraggingElementValue(), target)
  EventBus.$emit(Events.B_MENU_ITEM_DRAG_END)
}
